import React from "react";
import styled from "styled-components";
import Select from "react-select";
import PropTypes from "prop-types";
import CreatableSelect from "react-select/creatable";
import { AvField } from "availity-reactstrap-validation";
import { FIELD_STATUS, getInitialSelectParams } from "../../helpers/utils";

const CustomSelect = props => {
  const [select, setSelect] = React.useState({
    ...getInitialSelectParams(),
    value: props.defaultValue || "",
  });

  const handleChangeSelect = value => {
    if (Array.isArray(value) && value.length === 0)
      value = props.isMulti ? [] : "";

    setSelect(prev => ({
      ...prev,
      value,
      status:
        !props.required || (!!value && value?.length !== 0)
          ? FIELD_STATUS.SUCCESS
          : FIELD_STATUS.ERROR,
    }));

    if (props.onChange) props.onChange(value, props.name);
  };

  React.useEffect(() => {
    if (props.defaultValue && props.options) {
      setSelect(prev => {
        if (prev.status === FIELD_STATUS.INITIAL) {
          if (Array.isArray(props.defaultValue)) {
            return {
              ...prev,
              value: props.options.filter(i =>
                props.defaultValue.some(el => el.value === i.value)
              ),
            };
          } else {
            return {
              ...prev,
              value: props.options.find(
                i => i.value === props.defaultValue.value
              ),
            };
          }
        }
        return prev;
      });
    } else {
      setSelect({
        ...select,
        value: props.defaultValue || "",
      });
    }
  }, [props.defaultValue, props.options]);

  React.useEffect(() => {
    if (props.isFormSubmit) {
      handleChangeSelect(select.value);
    }
  }, [props.isFormSubmit]);

  let className = props.className || "";
  if (select.status === FIELD_STATUS.ERROR) {
    className = "select2-custom-error " + className;
  }

  if (props.name === "cpa_events") {
    // console.log(select);
  }

  return (
    <CustomSelectStyled>
      {props.name && (
        <AvField
          name={props.name}
          type="select"
          value={select.value}
          options={props.options}
          className="d-none"
          multiple={props.isMulti}
          validate={{ required: { value: !!props.required } }}
        />
      )}
      {!props.creatable ? (
        <Select
          {...props}
          className={className}
          value={select.value}
          onChange={val => handleChangeSelect(val)}
          onBlur={() => handleChangeSelect(select.value)}
          isDisabled={props?.isDisabled}
        />
      ) : (
        <CreatableSelect
          {...props}
          className={className + " creatable-select-hide-options-list"}
          value={select.value}
          onChange={val => handleChangeSelect(val)}
          onBlur={() => handleChangeSelect(select.value)}
          isDisabled={props?.isDisabled}
        />
      )}
      {select.status === FIELD_STATUS.ERROR && (
        <div className="invalid-feedback" style={{ display: "block" }}>
          {props.errorMessage}
        </div>
      )}
    </CustomSelectStyled>
  );
};

CustomSelect.propTypes = {
  className: PropTypes.any,
  error: PropTypes.any,
  errorMessage: PropTypes.any,
  creatable: PropTypes.bool,
  value: PropTypes.any,
  options: PropTypes.any,
  name: PropTypes.string,
  required: PropTypes.any,
  isFormSubmit: PropTypes.bool,
  onChange: PropTypes.func,
  defaultValue: PropTypes.any,
  isMulti: PropTypes.any,
  isDisabled: PropTypes.bool,
};

const CustomSelectStyled = styled.div`
  .select2-selection__control {
    &.select2-selection__control--is-focused {
      box-shadow: none !important;
      border-color: rgb(189,195,200) !important;

      &.select2-selection__control--menu-is-open {
        box-shadow: none !important;
        border-color: rgb(189,195,200) !important;
      }
    }
  }

  .select2-custom-error {
    .select2-selection__control {
      border-color: #f46a6a !important;
      box-shadow: none !important;
    }
  }

  .creatable-select-hide-options-list {
    .select2-selection__menu {
      display: none;
    }
  }

  .select2-selection--is-disabled {
    .select2-selection__control {
      cursor: default !important;
      background-color: #EFF2F7 !important;
      /* border-color: rgb(230, 230, 230) !important; */
      border: 1px solid #ced4da !important;;
      outline: 0px !important;
    }
  }

  .text-danger {
    display: none !important;
  }
`;

export default CustomSelect;
